import React from "react";

const AvgSaleIcon = ({ width = "14px", height = "14px", fill = "#3B82F6" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 14H6.66667C4.46667 14 3.36667 14 2.68333 13.3167C2 12.6333 2 11.5333 2 9.33333V2M4 8H4.006M5.99933 8H6.00467M7.998 8H8.00333M9.99667 8H10.0027M11.9953 8H12.0013M13.994 8H14"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 4.66671C4.44867 3.91871 5.058 3.33337 5.99533 3.33337C9.95733 3.33337 7.73 11.3334 11.988 11.3334C12.932 11.3334 13.5373 10.744 14 10"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AvgSaleIcon;
